import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/app/[locale]/pricing/components/PricingOfferButton.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/work/repo/redesign/components/ConversationPortrait.jsx");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/PlatformBackground.module.scss");
;
import(/* webpackMode: "eager" */ "/work/repo/redesign/components/PlatformFeaturePage.module.scss");
